import { DashboardSelect } from "./pages/DashboardSelect";
import { adaptV4Theme } from "@mui/material/styles";
import {
  Box,
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  Toolbar,
} from "@mui/material";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Login from "./pages/Login";
import LoginRedirect from "./pages/LoginRedirect";
import ApiStatus from "./pages/ApiStatus/ApiStatus";
import theme from "./utils/theme";
import RealTime from "./pages/RealTime";
import { AuthProvider } from "./contexts/auth";
import { Fallback, Unauthorized, NotFound } from "./pages/Fallback";
import { LocalizationProvider } from "@mui/x-date-pickers";
// import DateAdapter from "@mui/lab/AdapterMoment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ProtectedRoute from "./components/ProtectedRoute";
import { USER_TYPE } from "./utils/constants";
import { isExternalUser } from "./utils/auth";
import { UBDashboard } from "./pages/UnionBank/UBDashboard";
import { UBDashboardMock } from "./pages/UnionBankMock/UBDashboardMock";
import UBDashboardBackground from "./images/UBDashboardBackground.png";
import { ConditionalWrapper } from "./components/ConditionalWrapper";
import { UBRealTimeMock } from "./pages/UnionBankMock/UBRealTimeMock";
import moment from "moment";
import { useState } from "react";
import { UBDaily } from "./pages/UnionBank/UBDaily";
import { UBHourly } from "./pages/UnionBank/UBHourly";
import { UBError } from "./pages/UnionBank/UBError";
import { UBDetail } from "./pages/UnionBank/UBDetail";
import { UBEnrollment } from "./pages/UnionBank/UBEnrollment";
import { DownDetector } from "./pages/DownDetector/DownDetector";
import { LogUsage } from "./pages/LogUsage/LogUsage";
import { DownDetectorUpload } from "./pages/DownDetector/DownDetectorUpload";
import { Redirect } from "./components/Redirect";
import { useCookies } from "react-cookie";

const paths = [
  { name: "fidelity", api: "partner", title: "FIDELITY" },
  { name: "amazon", api: "partner", title: "AMAZON" },
  { name: "mobile", api: "internal-health", title: "MOBILE" },
  { name: "olb", api: "internal-health", title: "OLB" },
  { name: "backend", api: "internal-health", title: "BACKEND" },
];

const App = () => {
  let { tenantType } = window.localStorage;
  // Handle undefined, null, or string 'undefined' for tenantType
  if (!tenantType || tenantType === 'undefined' || tenantType === 'null') {
    tenantType = undefined;
  }
const isExternal = isExternalUser();



const routes = isExternal
    ? paths.filter(({ api }) => api === "partner")
    : paths.filter(({ api }) => api === "internal-health");
  const location = useLocation();
  let partner = location.pathname.replace("/", "").toUpperCase();
  const [locale, setLocale] = useState("en-us");

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  const darkTheme = createTheme(adaptV4Theme({ palette: { mode: "dark" } }));

  console.log("found tenant", tenantType)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale={locale}
          >
            <ConditionalWrapper
              condition={location?.pathname
                ?.split("/")?.[1]
                .includes("unionbank")}
              wrapper={(children) => (
                <Box
                  container
                  style={{
                    backgroundImage: `url(${UBDashboardBackground})`,
                    backgroundSize: "cover",
                    backgroundAttachment: "fixed",
                    height: "100%",
                    color: "#f5f5f5",
                  }}
                >
                  {children}
                </Box>
              )}
            >
              <Header partner={partner} isExternal={isExternal} />

              <Toolbar />

              <Routes>
                <Route
                  path="/"
                  element={
                    <Navigate
                      to={
                        isExternal
                          ?( tenantType
                            ? `/${tenantType.toLowerCase()}`
                            : "/login")
                          : "/mobile"
                      }
                    />
                  }
                />
                <Route
                  path="/fidelity"
                  element={<Navigate to="/fidelity/prod" />}
                />
                <Route
                  path="/amazon"
                  element={<Navigate to="/amazon/prod" />}
                />
                <Route path="/login" element={<Login />} />

                <Route path="/login-redirect" element={<LoginRedirect />} />

                {!isExternal && (
                  <Route
                    path="/unionbankmock"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBDashboardMock />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbankmock/realtime"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBRealTimeMock />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBDashboard />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard/hourly"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBHourly />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard/daily"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBDaily />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard/error"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBError />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard/detail"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBDetail />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/unionbank/:dashboard/summary"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={darkTheme}>
                          <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                            <UBEnrollment />
                          </ProtectedRoute>
                        </ThemeProvider>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/downdetector/*"
                    element={
                      <Redirect url="https://dashboard.us.bank-dns.com/pulse/down-detector" />
                    }
                  />
                )}

                {!isExternal && (
                  <Route
                    path="/log"
                    element={
                      <StyledEngineProvider injectFirst>
                        <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                          <LogUsage />
                        </ProtectedRoute>
                      </StyledEngineProvider>
                    }
                  />
                )}

                {isExternal &&
                  routes.map(({ name, api }) => (
                    <Route
                      path={`/${name}`}
                      element={<Navigate to={`/${name}/prod`} />}
                    />
                  ))}

                {routes.map(({ name, api }) => (
                  <Route
                    path={
                      api === "partner" ? `/${name}/:dashboard` : `/${name}`
                    }
                    element={
                      <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                        <ApiStatus
                          name={name}
                          api={api}
                          isExternal={isExternal}
                        />
                      </ProtectedRoute>
                    }
                  />
                ))}

                {routes.map(({ name, api }) => (
                  <Route
                    path={
                      api === "partner"
                        ? `/${name}/:dashboard/realtime`
                        : `/${name}/realtime`
                    }
                    element={
                      <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                        <RealTime
                          name={name}
                          api={api}
                          isExternal={isExternal}
                          pathname={name}
                        />
                      </ProtectedRoute>
                    }
                  />
                ))}

                {routes.map(({ name, api }) => (
                  <Route
                    path={
                      api === "partner"
                        ? `/${name}/:dashboard/realtime/:date`
                        : `/${name}/realtime/:date`
                    }
                    element={
                      <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                        <RealTime
                          name={name}
                          api={api}
                          isExternal={isExternal}
                          pathname={name}
                        />
                      </ProtectedRoute>
                    }
                  />
                ))}

                <Route path="/error" element={<Fallback />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/unavailable" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ConditionalWrapper>
          </LocalizationProvider>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
